module.exports = __webpack_public_path__ + "img/code2.052c19fd.png";